import { createClient } from "@supabase/supabase-js";

// Hard-coded Supabase config (anon key is public by design, RLS protects data)
const url = "https://ugibyjzwgjvpnlesrbsh.supabase.co";
const anon = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVnaWJ5anp3Z2p2cG5sZXNyYnNoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc3MjIyOTQsImV4cCI6MjA5MzI5ODI5NH0.fQvJcU-EwOsU6SUvJG-hLltZJHuH8MMymsOA8mAn4NQ";

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: typeof window !== "undefined" ? window.localStorage : undefined,
    storageKey: "sw-auth",
  },
});

export const INQUIRY_TYPES = [
  { value: "kuenstler-bewerbung", label: "Künstler-Bewerbung" },
  { value: "produzenten-bewerbung", label: "Produzenten-Bewerbung" },
  { value: "studio-booking", label: "Studio Booking" },
  { value: "management-anfrage", label: "Management Anfrage" },
  { value: "promotion-anfrage", label: "Promotion Anfrage" },
  { value: "strategie-beratung", label: "Strategie Beratung" },
  { value: "content-produktion", label: "Content Produktion" },
  { value: "sonstiges", label: "Sonstiges" },
];

export function formatSupabaseError(err, fallback = "Etwas ist schiefgelaufen.") {
  if (!err) return fallback;
  if (typeof err === "string") return err;
  return err.message || err.error_description || err.error || fallback;
}
